export default "__VITE_ASSET__C98A0MyR__"